import {
  GET_BOOKLETS,
  CREATE_BOOKLET,
  GET_BOOKLETS_REQUEST_PENDING,
  GET_BOOKLETS_REQUEST_SUCCESS,
  GET_BOOKLETS_REQUEST_ERROR,
  CREATE_BOOKLET_REQUEST_ERROR,
  UPDATE_BOOKLET,
  UPDATE_BOOKLET_REQUEST_ERROR,
  GET_BOOKLET,
  GET_BOOKLET_TRANSACTIONS,
  GET_BOOKLET_TRANSACTIONS_REQUEST_PENDING,
  GET_BOOKLET_TRANSACTIONS_REQUEST_SUCCESS,
  GET_BOOKLET_TRANSACTIONS_REQUEST_ERROR,
  GET_BOOKLET_TRANSACTION_GROUPS,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_PENDING,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_SUCCESS,
  GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_ERROR,
} from 'redux/types/booklets'

const initialState = {
  items: [],
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  item: {},
  transactionGroups: {
    result: [],
    total: 0,
  },
  isTransactionGroupsLoading: false,
  transactionGroupsErrors: [],
  transactions: {
    result: [],
    total: 0,
  },
  isTransactionsLoading: false,
  transactionsErrors: [],
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const booklets = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKLETS:
      return { ...state, ...action.payload }
    case CREATE_BOOKLET:
      return { ...state, items: [action.payload, ...state.items] }
    case GET_BOOKLET:
      return { ...state, item: action.payload }
    case GET_BOOKLET_TRANSACTION_GROUPS:
      return { ...state, transactionGroups: action.payload }
    case GET_BOOKLET_TRANSACTIONS:
      return { ...state, transactions: action.payload }
    case UPDATE_BOOKLET: {
      const items = state.items.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item,
      )
      const nextItem =
        state.item?.id === action.payload.id ? { ...state.item, ...action.payload } : state.item
      return { ...state, items, item: nextItem }
    }
    case GET_BOOKLETS_REQUEST_PENDING:
      return { ...state, isGetLoading: true, errors: [] }
    case GET_BOOKLETS_REQUEST_SUCCESS:
      return { ...state, isGetLoading: false }
    case GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_PENDING:
      return { ...state, isTransactionGroupsLoading: true, transactionGroupsErrors: [] }
    case GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_SUCCESS:
      return { ...state, isTransactionGroupsLoading: false }
    case GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_ERROR:
      return {
        ...state,
        isTransactionGroupsLoading: false,
        transactionGroupsErrors: [...state.transactionGroupsErrors, action.payload],
      }

    case GET_BOOKLET_TRANSACTIONS_REQUEST_PENDING:
      return { ...state, isTransactionsLoading: true, transactionsErrors: [] }
    case GET_BOOKLET_TRANSACTIONS_REQUEST_SUCCESS:
      return { ...state, isTransactionsLoading: false }
    case GET_BOOKLET_TRANSACTIONS_REQUEST_ERROR:
      return {
        ...state,
        isTransactionsLoading: false,
        transactionsErrors: [...state.transactionsErrors, action.payload],
      }

    case GET_BOOKLETS_REQUEST_ERROR:
    case CREATE_BOOKLET_REQUEST_ERROR:
    case UPDATE_BOOKLET_REQUEST_ERROR:
      return { ...state, isGetLoading: false, isChangeLoading: false, errors: [...state.errors, action.payload] }
    default:
      return state
  }
}

export default booklets
